import { useEffect } from "react";
import { monitoring } from "./index";
import { sentryAdapter } from "./adapters/sentryAdapter";

export const MonitoringProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  useEffect(() => {
    monitoring.register(sentryAdapter);
  }, []);

  return <>{children}</>;
};
